<template>
	<v-chip
		class="draggable-field-chip"
		:class="{ 'chip-used': isUsed, 'dragging': isDragging }"
		:draggable="true"
		small
		@dragstart="handleDragStart"
		@dragend="handleDragEnd"
	>
		<v-icon
			small
			class="field-chip__icon mr-1"
		>
			{{ fieldIcon }}
		</v-icon>
		<span class="field-chip__name">
			{{ getFieldName(field) }}
		</span>
		<div
			v-if="isUsed"
			class="field-chip__usage ml-1"
		>
			<v-chip
				x-small
				color="primary"
				dark
				class="usage-count"
			>
				{{ usageInfo.total }}
			</v-chip>
		</div>
	</v-chip>
</template>

<script>
import { VChip, VIcon } from 'vuetify/lib/components'
import { getFieldIcon } from './filterUtils.js'

export default {
	name: 'draggable-field-chip',
	components: {
		VChip,
		VIcon
	},
	props: {
		field: {
			type: Object,
			required: true
		},
		usageInfo: {
			type: Object,
			default: () => ({ total: 0, contexts: [] })
		}
	},
	data () {
		return {
			isDragging: false
		}
	},
	computed: {
		isUsed () {
			return this.usageInfo && this.usageInfo.total > 0
		},

		fieldIcon () {
			return getFieldIcon(this.field.typeFriendlyName)
		}
	},
	methods: {
		getFieldName (field) {
			return field.fieldName || field.name || 'Unknown Field'
		},
		handleDragStart (event) {
			// Store field data for drag and drop
			event.dataTransfer.setData('application/json', JSON.stringify({
				field: this.field,
				fieldName: this.field.fieldName
			}))

			// Set drag image
			event.dataTransfer.effectAllowed = 'copy'

			// Add visual feedback
			this.isDragging = true

			// Emit drag start event to parent
			this.$emit('dragstart', this.field)
		},

		handleDragEnd (event) {
			this.isDragging = false

			// Emit drag end event to parent
			this.$emit('dragend', this.field)
		}
	}
}
</script>

<style lang="scss" scoped>
.draggable-field-chip {
	cursor: grab;
	transition: all 0.2s ease;
	border: none !important;
	background-color: #ffffff !important;
	border-radius: var(--radius-lg, 12px) !important;
	height: 32px !important;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

	&:hover {
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		transform: translateY(-1px);
		background-color: var(--global-main-background-color) !important;
	}

	&.dragging {
		opacity: 0.6;
		transform: rotate(2deg) scale(0.95);
	}

	&.chip-used {
		background-color: var(--global-main-background-color) !important;
	}

	:deep(.v-chip) {
		background-color: inherit !important;
		border: inherit !important;
	}

	:deep(.v-chip__content) {
		display: flex;
		align-items: center;
		gap: 4px;
		padding: 0 12px !important;
	}
}

.field-chip__icon {
	color: var(--global-muted-foreground);
}

.field-chip__name {
	font-size: 13px;
	font-weight: 500;
	color: var(--global-foreground);
}

.field-chip__usage {
	display: flex;
	align-items: center;
}

.usage-count {
	min-width: 20px;
	height: 16px !important;
	font-size: 10px !important;
	font-weight: 600;
}
</style>
